'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-13d783d6.js');
var styled = require('styled-components');

var breakpoints = {
    breakpointIphone5: '320px',
    breakpointMobileSmall: '375px',
    breakpointTablet: '767px',
    breakpointMobile: '959px',
    breakpointDesktop: '960px',
    breakpointMidDesktop: '1024px',
    breakpointSemiWideScreens: '1224px',
    breakpointMidWideScreens: '1280px',
    breakpointWideScreens: '1440px',
    breakpointExtraWideScreens: '1536px',
    breakpointUltraWideScreens: '1790px',
};
var getBreakPointValue = function (breakpoint) {
    return parseInt(breakpoints[breakpoint].replace('px', ''), 10);
};
var generateMediaQueries = function (screenType) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    @media all and (min-width: ", ") {\n        ", "\n    }\n"], ["\n    @media all and (min-width: ", ") {\n        ", "\n    }\n"])), breakpoints[screenType], styled.css.apply(void 0, args));
}; };
var iphoneXMediaQuery = "\n    @media only screen \n    and (min-device-width : 375px) \n    and (max-device-width : 812px)\n    and (-webkit-device-pixel-ratio : 3)\n";
var forMobile = generateMediaQueries('breakpointMobile');
var forTablet = generateMediaQueries('breakpointTablet');
var forDesktop = generateMediaQueries('breakpointDesktop');
var forMidDesktop = generateMediaQueries('breakpointMidDesktop');
var forSemiWideScreens = generateMediaQueries('breakpointSemiWideScreens');
var forMidWideScreens = generateMediaQueries('breakpointMidWideScreens');
var forWideScreens = generateMediaQueries('breakpointWideScreens');
var forExtraWideScreens = generateMediaQueries('breakpointExtraWideScreens');
var forUltraWideScreens = generateMediaQueries('breakpointUltraWideScreens');
var forIPhone5 = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    @media all and (max-width: ", ") {\n        ", "\n    }\n"], ["\n    @media all and (max-width: ", ") {\n        ", "\n    }\n"])), breakpoints.breakpointIphone5, styled.css.apply(void 0, args));
};
var forMobileSmall = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    @media all and (max-width: ", ") {\n        ", "\n    }\n"], ["\n    @media all and (max-width: ", ") {\n        ", "\n    }\n"])), breakpoints.breakpointMobileSmall, styled.css.apply(void 0, args));
};
var forIE = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        ", "\n    }\n"], ["\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var forEdge = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    @supports (-ms-accelerator: true) or (-ms-ime-align: auto) {\n        ", "\n    }\n"], ["\n    @supports (-ms-accelerator: true) or (-ms-ime-align: auto) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var forIEandEdge = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n"])), forIE.apply(void 0, args), forEdge.apply(void 0, args));
};
var maxedPageWrapperStyle = styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    max-width: ", ";\n    margin: auto;\n"], ["\n    max-width: ", ";\n    margin: auto;\n"])), breakpoints.breakpointWideScreens);
var minmaxMatchRegex = /minmax\(\s*\w*\-*\w*\s*,\s*\w*\-*\w*\s*\)/g;
var safari10MinMaxFallBack = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var safari10fallback = args.map(function (cssProperty) {
        return cssProperty.toString().replace(minmaxMatchRegex, 'auto');
    });
    return styled.css(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n        ", "\n        ", "\n    "], ["\n        ", "\n        ", "\n    "])), safari10fallback.join(''), styled.css.apply(void 0, args));
};
var forSafari14andBefore = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    @supports (not (aspect-ratio: 1 / 1)) and (background: -webkit-named-image()) {\n        ", "\n    }\n"], ["\n    @supports (not (aspect-ratio: 1 / 1)) and (background: -webkit-named-image()) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var forSafari = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n    @supports (background: -webkit-named-image()) {\n        ", "\n    }\n"], ["\n    @supports (background: -webkit-named-image()) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var getWindowMediaMatch = function (screenType) {
    if (typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.matchMedia)) {
        var minWidth = breakpoints[screenType];
        var mediaQuery = window.matchMedia("all and (min-width: " + minWidth + ")");
        return mediaQuery.matches;
    }
    return false;
};
var getMediaStringValue = function (screenType, maxWidth, boundary) {
    if (boundary) {
        var numericBoundaryBreakPoint = Number(breakpoints[boundary].slice(0, -2));
        return "\n            (min-width: " + breakpoints[screenType] + ") and (max-width: " + (numericBoundaryBreakPoint - 1) + "px)\n        ";
    }
    return maxWidth ? "(max-width: " + breakpoints[screenType] + ")" : "(min-width: " + breakpoints[screenType] + ")";
};
var isTablet = function () { return getWindowMediaMatch('breakpointTablet'); };
var isDesktop = function () { return getWindowMediaMatch('breakpointDesktop'); };
var isMobile = function () { return getWindowMediaMatch('breakpointMobile'); };
var breakPointToMediaQuery = function (screenType) {
    var forX = {
        breakpointIphone5: forIPhone5,
        breakpointTablet: forTablet,
        breakpointMobile: forMobile,
        breakpointDesktop: forDesktop,
        breakpointMidDesktop: forMidDesktop,
        breakpointSemiWideScreens: forSemiWideScreens,
        breakpointMidWideScreens: forMidWideScreens,
        breakpointWideScreens: forWideScreens,
    };
    return forX[screenType];
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

exports.breakPointToMediaQuery = breakPointToMediaQuery;
exports.default = breakpoints;
exports.forDesktop = forDesktop;
exports.forEdge = forEdge;
exports.forExtraWideScreens = forExtraWideScreens;
exports.forIE = forIE;
exports.forIEandEdge = forIEandEdge;
exports.forIPhone5 = forIPhone5;
exports.forMidDesktop = forMidDesktop;
exports.forMidWideScreens = forMidWideScreens;
exports.forMobile = forMobile;
exports.forMobileSmall = forMobileSmall;
exports.forSafari = forSafari;
exports.forSafari14andBefore = forSafari14andBefore;
exports.forSemiWideScreens = forSemiWideScreens;
exports.forTablet = forTablet;
exports.forUltraWideScreens = forUltraWideScreens;
exports.forWideScreens = forWideScreens;
exports.getBreakPointValue = getBreakPointValue;
exports.getMediaStringValue = getMediaStringValue;
exports.iphoneXMediaQuery = iphoneXMediaQuery;
exports.isDesktop = isDesktop;
exports.isMobile = isMobile;
exports.isTablet = isTablet;
exports.maxedPageWrapperStyle = maxedPageWrapperStyle;
exports.minmaxMatchRegex = minmaxMatchRegex;
exports.safari10MinMaxFallBack = safari10MinMaxFallBack;
//# sourceMappingURL=index.js.map
